import React from "react";
import "./Careers.css";
import { Link } from "react-router-dom";

/* ── Job openings — content unchanged from request ── */
const JOBS = [
  {
    icon: "💻",
    word: "Frontend",
    title: "Frontend Developer",
    location: "Remote / India",
    experience: "1–3 Years",
    type: "Full Time",
  },
  {
    icon: "🛠️",
    word: "Backend",
    title: "Backend Developer",
    location: "Indore",
    experience: "2–4 Years",
    type: "Full Time",
  },
  {
    icon: "🎨",
    word: "Design",
    title: "UI/UX Designer",
    location: "Remote",
    experience: "0–2 Years",
    type: "Internship",
  },
];

/* ── Sketch SVG arrows (same pattern as Expertise / About) ── */
function SketchArrows() {
  return (
    <svg className="sketch-arrows" viewBox="0 0 360 220" xmlns="http://www.w3.org/2000/svg">
      <path d="M40 110 Q110 60 180 110" stroke="#E8571A" strokeWidth="1.2" fill="none" strokeDasharray="4 3" opacity="0.3" />
      <path d="M180 110 Q250 160 320 110" stroke="#1A2235" strokeWidth="1.2" fill="none" strokeDasharray="4 3" opacity="0.2" />
      <path d="M90 40 Q130 110 90 180" stroke="#E8571A" strokeWidth="1" fill="none" strokeDasharray="3 4" opacity="0.18" />
      <path d="M270 40 Q230 110 270 180" stroke="#1A2235" strokeWidth="1" fill="none" strokeDasharray="3 4" opacity="0.15" />
    </svg>
  );
}

/* ── Floating keyword words (same pattern as Expertise / About) ── */
function SketchWords({ words }) {
  const positions = [
    { top: "14%", left: "8%" },
    { top: "14%", right: "8%" },
    { bottom: "14%", left: "8%" },
    { bottom: "14%", right: "8%" },
    { top: "50%", left: "4%", transform: "translateY(-50%)" },
    { top: "50%", right: "4%", transform: "translateY(-50%)" },
  ];

  return words.slice(0, 6).map((w, i) => (
    <span key={i} className="sketch-word" style={positions[i]}>
      {w}
    </span>
  ));
}

export default function Careers() {
  return (
    <section className="careers-page" id="careers">

      <div className="careers-sec">

        {/* Header */}
        <div className="exp-header">
          <p className="exp-eyebrow">
            <span className="eyebrow-dot"></span>
            Careers
          </p>
          <h2 className="exp-title">
            Build Your Career<br />
            <span className="title-orange">With Us</span>
          </h2>
          <p className="exp-subtitle">
            Join a team where innovation, growth, and impact matter.
          </p>
        </div>

        {/* Jobs grid — same exp-grid system as Expertise/About */}
        <div className="exp-grid count-3">
          {JOBS.map((job) => (
            <div className="exp-card job-card" key={job.title}>

              {/* Sketch top area */}
              <div className="sketch-wrap job-sketch-wrap">
                <SketchArrows />
                <SketchWords words={[job.location, job.experience, job.type, "Apply", "Join", "Build"]} />
                <span className="sketch-pill">{job.icon}</span>
                <div className="sketch-center">
                  <span className="sketch-center-icon">{job.icon}</span>
                  <span className="sketch-center-text">{job.word}</span>
                </div>
              </div>

              {/* Card body */}
              <div className="exp-card-body">
                <h3 className="exp-card-title">{job.title}</h3>

                <div className="job-meta">
                  <span className="job-meta-item">{job.location}</span>
                  <span className="job-meta-sep">•</span>
                  <span className="job-meta-item">{job.experience}</span>
                  <span className="job-meta-sep">•</span>
                  <span className="job-meta-item">{job.type}</span>
                </div>

               <Link to="/contact" className="job-cta">
  View Details
</Link>
              </div>

            </div>
          ))}
        </div>

      </div>
   
    
    </section>
  );
}
